"use strict";

const hermite = 10;
const catmull = 11;

export default class EVSpline {
    constructor(points, degree) {
        this.points = points;
        this.length = points.length;
        this.degree = degree;
        this.prev_point = 0;

        this.tangents = undefined;       // Only used for Hermite.

    }

    //
//
//

    value(value) {
        if (this.points[0].x > value) {
            return this.points[0].y;
        } else if (this.points[this.length - 1].x < value) {
            return this.points[this.length - 1].y;
        } else {
            for (let i = 0; i < this.length; i++) {
                const index = (i + this.prev_point) % this.length;

                if (this.points[index].x === value) {
                    this.prev_point = index;
                    return this.points[index].y;
                } else if ((this.points[index].x < value) && (value < this.points[index + 1].x)) {
                    this.prev_point = index;
                    return this.calc(value, index);
                }
            }
        }

        return 0.0;
    };

//
//
//


    calc(value, index) {
        switch (this.degree) {
            case 0:
                return this.points[index].y;

            case 1:
                if (this.points[index].x === this.points[index + 1].x) {
                    // Avoids division by 0
                    return this.points[index].y;
                } else {
                    return this.points[index].y + (this.points[index + 1].y - this.points[index].y)
                        * (value - this.points[index].x) / (this.points[index + 1].x - this.points[index].x);
                }

            case hermite:
                return this.hermite(((value - this.points[index].value) / (this.points[index + 1].value - this.points[index].value)),
                    this.points[index].y,
                    this.points[index + 1].y,
                    this.tangents[index],
                    this.tangents[index + 1],
                    this.points[index].x,
                    this.points[index + 1].x);

            case catmull:
                if (index === 0) {
                    // x prior to spline start - first point used to determine tangent
                    return this.points[1].y;
                } else if (index === this.length - 2) {
                    // x after spline end - last point used to determine tangent
                    return this.points[this.length - 2].y;
                } else {
                    const t = (value - this.points[index].x) / (this.points[index + 1].x - this.points[index].x);
                    const m0 = (index === 0 ? 0 : this.catmull_tangent(index));
                    const m1 = (index === this.length - 1 ? 0 : this.catmull_tangent(index + 1));
                    return this.hermite(t, this.points[index].y, this.points[index + 1].y,
                        m0, m1, this.points[index].x, this.points[index + 1].x);
                }
        }

        return 0.0;
    };

//
//
//

    hermite(t, p0, p1, m0, m1, x0, x1) {
        return (this.hermite_00(t) * p0) + (this.hermite_10(t) * (x1 - x0) * m0)
            + (this.hermite_01(t) * p1) + (this.hermite_11(t) * (x1 - x0) * m1);
    };

//
//
//

    hermite_00(t) {
        return (2 * Math.pow(t, 3)) - (3 * Math.pow(t, 2)) + 1;
    };

//
//
//

    hermite_10(t) {
        return Math.pow(t, 3) - (2 * Math.pow(t, 2)) + t;
    };

//
//
//

    hermite_01(t) {
        return (3 * Math.pow(t, 2)) - (2 * Math.pow(t, 3));
    };

//
//
//

    hermite_11(t) {
        return Math.pow(t, 3) - Math.pow(t, 2);
    };

//
//
//


    catmull_tangent(i) {
        if (this.points[i + 1].x === this.points[i - 1].x) {
            // Avoids division by 0
            return 0;
        } else {
            return (this.points[i + 1].y - this.points[i - 1].y)
                / (this.points[i + 1].x - this.points[i - 1].x);
        }
    };


//
// Return a single interpolated y.
//

    getY(x) {
        return this.value(x);
    };

//
// Return a interpolated dataset for graphing.
//

    interpolatedPoints(num_points) {
        const points = [];
        const min = this.points[0].x;
        const max = this.points[this.length - 1].x;
        const increment = (max - min) / num_points;
        for (let i = min; i <= max; i += increment) {
            const datapoint = [];
            datapoint["value"] = i;
            datapoint["risk"] = this.getY(i);
            points.push(datapoint);
        }

        return points;
    };


}
